<script>
// import axios from 'axios'
// import qs from 'qs'

import PartnerList from "@/components/admin/common/list/PartnerList.vue"
import Title from "@/components/admin/common/TitleArea.vue"

import PartnerInfoForm from "@/components/admin/common/modal/PartnerInfoForm.vue"

export default {
  name: "Admin-Customer-management",
  meta: {
    title: "어드민-파트너정보조회"
  },
  components: {
    PartnerList,
    Title,
    PartnerInfoForm
  },
  data() {
    return {
      description   : {
        title : '파트너 관리'
      },
      partnerModifyModalShow : false
    }
  },
  computed: {
    session() {
      return this.$store.getters.getLocalSession || {}
    }
  },
  methods:{
    async onPartnerRegistered() {
      this.partnerModifyModalShow = false
      await this.$refs.partnerListRef?.getPartnerList?.()
    }
  }
}
</script>

<template>

  <q-page class="q-pa-lg">
    <div class="row q-mb-lg">
      <div class="col">
        
        <Title
          :desc="description">
          <q-btn
            color="primary"
            size="md"
            label="파트너사 추가"
            @click="() => { partnerModifyModalShow = true }"/>
        </Title>  

      </div>
    </div>

    <div class="row">
      <div class="col">
        <div class="comp-box">
          <PartnerList ref="partnerListRef" />
        </div>
      </div>
    </div>
  </q-page>

  <!-- 파트너사 수정 모달 -->
  <teleport to="body">
    <q-dialog 
      v-model="partnerModifyModalShow">

      <PartnerInfoForm
        :authLevel="String(session.authLevel || '')"
        mode="create"
        @partnerRegistered="onPartnerRegistered" />
    
    </q-dialog>
  </teleport>

</template>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>
